import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit, ViewChildren, ElementRef } from '@angular/core';
import { MatDialog, MatSelect } from '@angular/material';
import { DatePipe, Location } from '@angular/common';

import { BranchService } from 'src/app/core/services/branch.service';
import { CommonService } from 'src/app/core/services/common.service';
import { Subscription, ReplaySubject, Subject } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm, FormControl } from '@angular/forms';
import { UploadMultiFileComponent } from 'src/app/shared/components/upload-multi-file/upload-multi-file.component';
import { BaseComponent } from 'src/app/shared/components/base/base.component';
import { first, map, takeUntil } from 'rxjs/operators';
import { BreadcrumbsService } from 'src/app/shared/components/breadcrumbs/breadcrumbs.service';
import { Message } from 'src/app/core/class/message';
import { ToastrService } from 'ngx-toastr';
import { CustomerFilterLanguage } from 'src/app/core/class/customer-filter-language';
import { EnterpriseTypes } from 'src/app/core/constants/enterprise-type';

@Component({
  selector: 'app-view-detail-branch',
  templateUrl: './view-detail-branch.component.html',
  styleUrls: ['./view-detail-branch.component.scss']
})
export class ViewDetailBranchComponent extends BaseComponent implements OnInit, AfterViewInit {
  maxDate = new Date();
  minDate = new Date(1899, 12, 1);
  oldBranchName;
  enterpriseType: any;
  type: any;
  certificate: any;
  personalId = EnterpriseTypes.PERSONAL;
  representativeCertificate: any;
  representativeCertificateName: any;

  branch = {
    adminUser: '',
    id: null,
    parentId: localStorage.getItem('enterpriseId'),
    tenantId: localStorage.getItem('tenantId'),
    name: '',
    foreignName: '',
    abbreviation: '',
    taxCode: '',
    phone: '',
    fax: '',
    primaryEmail: '',
    email: '',
    certificateId: null,
    certificateNo: '',
    issuedDate: '',
    issuedAt: '',
    accountNumber: '',
    bankName: '',
    bankBranch: '',
    representative: '',
    position: '',
    representativeCertificateId: null,
    representativeCertificateNo: '',
    representativeIssuedDate: '',
    representativeIssuedOn: '',
    birthday: '',
    sex: null,
    businessType: null,
    enterpriseType: null,
    status: null,
    isDeleted: null,
    attachments: [],
    parentName: '',
    version: '',
    addresses: [
      {
        cityId: null,
        wardId: null,
        districtId: null,
        address: ''
      }
    ]
  };

  cities: comboBox[] = [];
  districts: districtsComboBox[] = [];
  wardName: any;
  wards: wardsCombobox[] = [];
  districtName: any;
  cityName: any;
  show = true;

  searchtenantId: '';
  searchPage: number;
  searchPageSize: number;
  searchParentId: '';
  searchKeyword: '';
  searchStatus: [];

  certificateType: any;
  representativeCertificateType: any;

  private _onDestroy = new Subject<void>();

  // Variable to subscribe to error
  subscription: Subscription;


  // Refer to form in view
  @ViewChild('f', { static: false }) ngForm: NgForm;
  // Subscribe to form changing
  formChangesSubscription: Subscription;
  // Whether the form change or not

  @ViewChildren('focusInput') focusInput;

  constructor(
    // public dialogRef: MatDialogRef<UpdateBranchComponent>,
    // @Inject(MAT_DIALOG_DATA) public data: any,
    private el: ElementRef,
    private branchService: BranchService,
    public commonService: CommonService,
    public datepipe: DatePipe,
    public dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    private breadcrumbsService: BreadcrumbsService,
    public message: Message,
    private toastr: ToastrService,
    public customerFilter: CustomerFilterLanguage,
    public location: Location,
  ) {
    super(commonService, message);
    this.branch.id = this.route.snapshot.paramMap.get('id');
  }

  /**
   * Get initial data
   */
  ngOnInit() {
    this.loadCities();
    this.loadDistricts();
    this.loadWards();

    this.commonService.getCategory().subscribe(result => {
      this.cities = result[0].data;
      this.districts = result[1].data;
      this.wards = result[2].data;
      this.getBranch(this.branch.id);
    })

    window.scrollTo(0, 0);
    this.breadcrumbsService.store([
      { label: 'breadcrumbs.home', url: 'main', params: [], highlight: false },
      { label: 'breadcrumbs.enterprise_manage', url: '', params: [], highlight: false },
      { label: 'breadcrumbs.branch', url: 'branches', params: [], highlight: false },
      { label: 'breadcrumbs.view_info_branch', url: 'view-detail-branch/:id', params: [this.branch.id], highlight: false },
    ]);

    this.subscription = this.route
      .queryParams
      .subscribe(params => {
        // Defaults to 0 if no query param provided.
        this.searchtenantId = params.tenantId || 0;
        this.searchPage = params.page || 0;
        this.searchPageSize = params.pageSize || 0;
        this.searchParentId = params.parentId || '';
        this.searchKeyword = params.keyword || '';
        this.searchStatus = params.status;
      });
  }

  ngAfterViewInit() {
    setTimeout(_ => this.focusInput.first.nativeElement.focus());
  }

  /**
   * Get cities list from local storage or api
   */
  loadCities() {
    // if (localStorage.getItem('cities') === null) {
    this.commonService.getAllCityRedis().subscribe(rs => {
      const data = rs.data;
      if (data != null && data.length > 0) {
        this.cities = data;
        localStorage.setItem(
          'cities',
          JSON.stringify(this.cities),
        );
      }
    });
  }

  /**
   * Get districts list from local storage or api
   */
  loadDistricts() {
    // if (localStorage.getItem('districts') === null) {
    this.commonService.getAllDistrictsRedis().subscribe(rs => {
      const data = rs.data;
      if (data != null && data.length > 0) {
        this.districts = data;
        localStorage.setItem(
          'districts',
          JSON.stringify(this.districts),
        );
      }
    });
    // } else {
    //   this.districts = JSON.parse(
    //     localStorage.getItem('districts')
    //   );
    // }
  }

  /**
   * Get wards list from local storage or api
   */
  loadWards() {
    // if (localStorage.getItem('wards') === null) {
    this.commonService.getAllWardRedis().subscribe(rs => {
      const data = rs.data;
      if (data != null && data.length > 0) {
        this.wards = data;
        localStorage.setItem(
          'wards',
          JSON.stringify(this.wards),
        );
      }
    });
    // } else {
    //   this.wards = JSON.parse(
    //     localStorage.getItem('wards')
    //   );
    // }
  }

  /**
   * Get parent branches for creating branch
   */
  getBranch(id: number) {
    this.branchService.getBranch(id).subscribe(
      rs => {
        if (rs == null || rs.data == null) {
          return 0;
        }
        console.log(rs.data);
        this.branch = {
          ...this.branch,
          ...rs.data,
          issuedDate: rs.data.issuedDate != null ? this.datepipe.transform(new Date(rs.data.issuedDate), 'dd-MM-yyyy') : null,
          representativeIssuedDate: rs.data.representativeIssuedDate != null ? this.datepipe.transform(new Date(rs.data.representativeIssuedDate), 'dd-MM-yyyy') : null,
          birthday: rs.data.birthday != null ? this.datepipe.transform(new Date(rs.data.birthday), 'dd-MM-yyyy') : null,
        };
        this.oldBranchName = rs.data.name;
        if (this.branch.addresses[0] === undefined || this.branch.addresses.length == 0) {
          this.branch.addresses[0] = {
            cityId: null,
            wardId: null,
            districtId: null,
            address: ''
          };
        } else {
          var cityItem = (this.branch.addresses[0].cityId != null) ? this.cities.find(x => x.id === this.branch.addresses[0].cityId) : undefined;
          this.cityName = (cityItem != undefined) ? cityItem.name : '';
          var districtItem = (this.branch.addresses[0].districtId != null) ? this.districts.find(x => x.id === this.branch.addresses[0].districtId): undefined;
          this.districtName = (districtItem != undefined) ? districtItem.name : '';
          var wardItem = (this.branch.addresses[0].wardId != null) ? this.wards.find(x => x.id === this.branch.addresses[0].wardId) : undefined;
          this.wardName = (wardItem != undefined) ? wardItem.name : '';

          this.getEnterpriseType();
          this.getCertificateType();
          this.getRepresentativeCertificateType();
        }
      }
    );
  }

  getCertificateType() {
    this.commonService.getCertificateType().subscribe(rs => {
      if (rs && rs.data) {
        this.certificateType = rs.data;
        if (this.branch.enterpriseType !== this.personalId) {
          this.certificate = this.certificateType.find(x => x.id === this.branch.certificateId).langs;
        }
      }
    });
  }

  getRepresentativeCertificateType() {
    this.commonService.getRepresentativeCertificateType().subscribe(rs => {
      if (rs && rs.data) {
        this.representativeCertificateType = rs.data;
        this.commonService.getCertificateType().subscribe(rs2 => {
          if (rs2 && rs2.data) {
            // Concat list getCertificateType and getRepresentativeCertificateType
            this.representativeCertificateType = this.representativeCertificateType.concat(rs2.data);
            if (this.branch.enterpriseType === this.personalId) {
              this.representativeCertificate = this.representativeCertificateType.find(x => x.id === this.branch.certificateId);
            } else {
              this.representativeCertificate = this.representativeCertificateType.
                find(x => x.id === this.branch.representativeCertificateId);
            }
            this.representativeCertificateName = this.representativeCertificate !== undefined ? this.representativeCertificate.langs : '';
          }
        });
      }
    });
  }

  getEnterpriseType() {
    this.commonService.getEnterpriseType().subscribe(rs => {
      if (rs && rs.data) {
        this.type = rs.data.find(x => x.id === this.branch.enterpriseType).langs;
      }
    });
  }

  getEnterpriseTypeOptions(options) {
    return this.customerFilter.filterOptionsData(options);
  }

  onBack() {
    this.location.back();
  }
}
